var _circle, _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 55,
    viewBox: "0 0 73 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 27.5,
    r: 27.5,
    fill: "#819FFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_508_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9287 35.8947C57.3176 35.8947 57.3176 33.5 57.3176 33.5C57.3176 33.5 57.3176 31.1053 54.9287 31.1053C52.5398 31.1053 52.5398 32.1774 52.5398 33.5C52.5398 34.8226 52.5398 35.8947 54.9287 35.8947Z",
    fill: "#B8C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.27 30.421C58.0001 30.421 58.0001 27.6842 58.0001 27.6842C58.0001 27.6842 58.0001 24.9474 55.27 24.9474C52.5398 24.9474 52.5398 26.1727 52.5398 27.6842C52.5398 29.1957 52.5398 30.421 55.27 30.421Z",
    fill: "#B8C9FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_508_615)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4444 14C51.8571 14 53.9047 16.0526 53.9047 19.4737V25.6316C53.9047 27.5148 53.2842 28.9833 52.1571 29.9231C53.1778 30.7119 53.9047 31.9349 53.9047 33.1579C53.9047 37.2632 51.1746 40 47.0793 40H21.1428C19.4365 40 19.0952 39.6579 19.0952 37.9474V31.1053V29.0526V20.8421C19.0952 16.7368 21.8254 14 25.9206 14H48.4444Z",
    fill: "#F2F5FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_508_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7619 32.4737H29.3333C27.9684 32.4737 27.9683 32.8158 27.9683 33.5C27.9683 34.1842 28.6508 35.2105 32.746 35.2105H44.3492C48.4444 35.2105 49.127 34.1842 49.127 33.5C49.127 32.8158 49.1268 32.4737 47.7619 32.4737Z",
    fill: "#FFB185"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_508_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6507 16.0526H48.4444C50.492 16.0526 51.8571 18.1052 51.8571 20.1579V24.9473C51.8571 27 50.492 29.0526 48.4444 29.0526H28.6507C26.6031 29.0526 25.238 27 25.238 24.9473V20.1579C25.238 18.1052 26.6031 16.0526 28.6507 16.0526Z",
    fill: "#9AB2FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_508_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7461 26.3158C35.0079 26.3158 36.8414 24.4778 36.8414 22.2105C36.8414 19.9432 35.0079 18.1053 32.7461 18.1053C30.4844 18.1053 28.6509 19.9432 28.6509 22.2105C28.6509 24.4778 30.4844 26.3158 32.7461 26.3158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7144 26.3158C47.9761 26.3158 49.8096 24.4778 49.8096 22.2105C49.8096 19.9432 47.9761 18.1053 45.7144 18.1053C43.4526 18.1053 41.6191 19.9432 41.6191 22.2105C41.6191 24.4778 43.4526 26.3158 45.7144 26.3158Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_508_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0715 35.8947C20.4604 35.8947 20.4604 34.8226 20.4604 33.5C20.4604 32.1774 20.4604 31.1053 18.0715 31.1053C15.6826 31.1053 15.6826 33.5 15.6826 33.5C15.6826 33.5 15.6826 35.8947 18.0715 35.8947Z",
    fill: "#B8C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7302 30.421C20.4603 30.421 20.4603 29.1957 20.4603 27.6842V27.6842C20.4603 26.1727 20.4603 24.9474 17.7302 24.9474C15 24.9474 15 27.6842 15 27.6842C15 27.6842 15 30.421 17.7302 30.421Z",
    fill: "#B8C9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_508_615",
    x: 47.5398,
    y: 21.9474,
    width: 13.4602,
    height: 18.9474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_508_615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_508_615",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_508_615",
    x: 14.0952,
    y: 11,
    width: 42.8096,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_508_615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_508_615",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_508_615",
    x: 27.9683,
    y: 32.4737,
    width: 21.1587,
    height: 2.73685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_508_615"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_508_615",
    x: 25.238,
    y: 16.0526,
    width: 26.6191,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_508_615"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_508_615",
    x: 20.6509,
    y: 10.1053,
    width: 37.1587,
    height: 24.2105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_508_615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_508_615",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_508_615",
    x: 10,
    y: 21.9474,
    width: 13.4604,
    height: 18.9474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_508_615"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_508_615",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.e92c5e0f0860047049afce95c2ceb4ad.svg";
export { ForwardRef as ReactComponent };